import React from 'react';
import { Icon } from 'components';
import cn from 'classnames';
import './index.scss';

export const Tooltip = ({
	text,
	position,
	className,
	toolTipClasses,
	withIcon = true,
	children,
	normalWs = false
}: {
	text: string;
	position: 'top' | 'bottom';
	className?: string;
	toolTipClasses?: string;
	withIcon?: boolean;
	children?: any;
	normalWs?: boolean;
}) => {
	const whitespace = normalWs ? 'whitespace-normal w-[230px] min-h-auto' : 'whitespace-nowrap';
	const classes = cn(
		'tooltip-text absolute rounded opacity-0 duration-300 bg-black text-white px-3 py-2 text-[10px] z-99',
		{
			'-top-[42px] -left-[4px]': position === 'top',
			'top-[20px] -left-[4px]': position === 'bottom',
		},
		whitespace,
		toolTipClasses
	);

	return (
		<div className={cn('relative tooltip-container', className)}>
			{children}
			<span className={classes}>{text}</span>
			{withIcon && <Icon name='Question' />}
		</div>
	);
};
